export enum FeatureService {
  LOGGER = 's2:logger',
  LOCALE_SERVICE = 'locale-service',
  MYDEALER_SERVICE = 'mydealer-service',
  MYDEALER_CONFIGURATION_SERVICE = 'mydealer-configuration-service',
  TRACKING_SERVICE = 'tracking',
  FEATURE_APP_SERVICE = 'featureapp-service',
  VW_AUTH_SERVICE = 'vw:authService',
  PAGE_INFO_SERVICE = 'page-info-service',
  SERIALIZED_STATE_MANAGER = 's2:serialized-state-manager',
  CONTENT_SERVICE = 'fa-content-service',
}
